import { AdditionalInformation } from '../common/additional-information';
import { DeclarationCustomer } from '../common/declaration-customer';
import { ProducedDocumentsWritingOffHeader } from '../common/produced-document-writing-off-header';
import { SimplifiedDeclarationDocumentWritingOffHeader } from '../common/simplified-declaration-document-writing-off-header';
import { SupplyChainActor } from '../common/supply-chain-actor';
import { Declaration, Notifiable } from '../declaration';
import { DeclarationExternalEntity } from '../enums/common/declaration-external-entity';
import { DeclarationInternalType } from '../enums/common/declaration-internal-type';
import { IrelandNotificationType } from './ireland-notification';

export const etdNameLabels = [
    {
        key: 'ETD',
        value: '(ETD) Electronic Transit Declaration',
    },
];

export interface ElectronicTransportDocumentPayload extends Declaration {
    declarationExternalEntity?: DeclarationExternalEntity.REVENUE;
    declarationInternalType?: DeclarationInternalType.ETD;
    isCoreTemplate?: boolean;
    irelandETDDeclaration?: ElectronicTransportDocument;
}

export interface ElectronicTransportDocument extends Notifiable<EtdNotification> {
    declaration?: ElectronicTransportDocumentDeclaration;
    goodsShipment?: EtdGoodsShipment;
}

export interface ElectronicTransportDocumentDeclaration {
    lrn?: string;
    transitDeclaration?: string;
    goodsInformation?: GoodsInformation;
    customsOffices?: CustomsOffice;
    parties?: Parties;
    messageType?: string;
}

export interface EtdGoodsShipment {
    id?: string;
    documentsAuthorisations?: DocumentAuthorisation;
    parties?: Parties;
    datesPlaces?: DatesPlaces;
    transportInformation?: TransportInformation;
    goodsShipmentItem?: GoodsShipmentItem[];
}

export interface GoodsInformation {
    grossMass65?: number;
    goodsDescription?: string;
    packaging?: Package[];
    cusCode?: string;
    commodityCode?: {
        combinedNomenclatureCode?: string;
    };
}
export interface CustomsOffice {
    customsOfficeLodgement?: string;
    customsOfficeOfDestination?: string;
}

export interface Package {
    typePackage?: string;
    packageNumber610?: string;
    shippingMarks?: string;
}

export interface Parties {
    consignee?: DeclarationCustomer;
    supplyChainActor?: SupplyChainActor[];
}

export interface DocumentAuthorisation {
    simplifiedDeclarationDocumentWritingOff?: SimplifiedDeclarationDocumentWritingOffHeader[];
    additionalInformation?: AdditionalInformation[];
    producedDocumentsWritingOff?: ProducedDocumentsWritingOffHeader[];
    ucr?: string;
}

export interface DatesPlaces {
    countryDestination?: string;
}

export interface TransportInformation {
    departureTransportMeans?: DepartureTransportMeans;
    nationality?: string;
    containerIdentificationNumber?: ContainerIdentificationNumbers[];
}

export interface ContainerIdentificationNumbers {
    containerIdentificationNumber?: string;
}

export interface DepartureTransportMeans {
    identificationType?: string;
    identificationNumber?: string;
}

export interface DepartureTransportMeans {
    identificationType?: string;
    identificationNumber?: string;
}

export interface GoodsShipmentItem {
    id?: string;
    goodsItemNumber?: string;
    transitDeclaration?: string;
    documentsAuthorisations?: DocumentAuthorisation;
    parties?: Parties;
    datesPlaces?: DatesPlaces;
    goodsInformation?: GoodsInformation;
    transportInformation?: TransportInformation;
}

export interface EtdNotification {
    id?: string;
    notificationId?: string;
    type: IrelandNotificationType;
    message: string;
    notificationDate: string;
    consumed: boolean;
}
